
import FormInput from "../UI/FormInput";
import i18n from "i18n";

const AddressInput = ({ label = i18n.t("common:address"), placeholder = i18n.t("common:address"), id = null, required = true, helperText = null }) => (
  <FormInput
    label={label}
    placeholder={placeholder}
    type="text"
    id={`${id ? id + "_" : ""}address`}
    autoComplete={`${id ? id + " " : ""}address`}
    required={required}
    helperText={helperText}
  />
);

export default AddressInput;